import Head from 'next/head'
import Link from 'next/link'
import nookies from 'nookies'

import { isBlank } from 'utils'

import { useCart } from 'hooks'

import Button from 'components/Button'
import Cart from 'components/Cart'
import CartSummary from 'components/CartSummary'
import Divider from 'components/Divider'
import Header from 'components/Header'
import Spacer from 'components/Spacer'

import { CartContainer, CartSummaryWrapper, Root } from './cart.style'

export default function CartPage() {
  const { cart } = useCart()

  return (
    <>
      <Head>
        <title>Cart - The Armoury</title>
      </Head>
      <Root>
        {isBlank(cart?.lines?.edges) ? (
          <>
            <Header>Your cart is empty</Header>
            <Spacer y={6} />
            <Link href="/" passHref legacyBehavior>
              <Button text="Continue shopping" variant="outlined" as="a" />
            </Link>
          </>
        ) : (
          <>
            <Header>Cart</Header>
            <Spacer y={6} />
            <CartContainer>
              <Cart cart={cart} />
              <CartSummaryWrapper>
                <CartSummary cart={cart} />
              </CartSummaryWrapper>
            </CartContainer>
          </>
        )}
      </Root>
      <Divider />
    </>
  )
}

export async function getServerSideProps(ctx) {
  const cookies = nookies.get(ctx)

  return { props: { cookies } }
}
